import React from "react";
import { useTranslation } from "react-i18next";

/** Banner cookie — chỉ gọi callback; App.jsx mới commit preferences + cookie ngôn ngữ */
const Cookies = ({ onAcceptAll, onRejectAll, onPreferences }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`
        sticky bottom-0 left-0 right-0 z-50
        p-[1%] transition-colors duration-300
        bg-[#346DDB]
        border-t border-white/10
        text-[#F8FAFC]
      `}
    >
      <div className="mx-auto flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="leading-relaxed">
          <p className="font-bold text-[16px]">
            {t("cookies.title")}
          </p>
          <p className={`mt-1 text-[15px]`}>
            {t("cookies.description")}
          </p>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:items-center whitespace-nowrap">
          <button
            onClick={onPreferences}
            className={`
              rounded-md border p-[10px] h-[48px] text-[15px] font-normal transition-all md:w-[200px]
            `}
          >
            {t("cookies.preferences")}
          </button>

          <button
            onClick={() => onRejectAll?.()}
            className={`
    rounded-md border p-[10px] h-[48px] text-[15px] font-normal transition-all md:w-[200px]
  `}
          >
            {t("cookies.rejectAll")}
          </button>

          <button
            onClick={() => onAcceptAll?.()}
            className={`
    rounded-md p-[10px] h-[48px] text-[15px] font-normal transition-all bg-[#F8FAFC] text-[#020617] md:w-[200px] flex items-center justify-center
  `}
          >
            {t("cookies.acceptAll")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
